import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const TONE_LABELS = {
    warm_professional: 'Warm & Professional',
    concise: 'Clear & Concise',
    formal: 'Formal',
};

function SummaryRow({ emoji, label, value, isOn }) {
    return (
        <Box sx={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            p: '12px 16px', borderBottom: '1px solid #EBEBEB', backgroundColor: '#fff',
            '&:last-child': { borderBottom: 'none' },
        }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Typography sx={{ fontSize: 16 }}>{emoji}</Typography>
                <Typography sx={{ fontSize: 13, color: '#3D3D3D', fontWeight: 500 }}>{label}</Typography>
            </Box>
            <Typography sx={{
                fontSize: 12.5, fontWeight: 700,
                color: isOn ? '#00A76F' : '#B0B0B0',
            }}>
                {value || (isOn ? 'Enabled' : 'Disabled')}
            </Typography>
        </Box>
    );
}

SummaryRow.propTypes = {
    emoji: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    isOn: PropTypes.bool,
};

SummaryRow.defaultProps = {
    value: '',
    isOn: false,
};

function getTreatmentLabel(fd) {
    if (fd.auto_send_treatment_template) return 'Assign & Reply';
    return 'Assign Only';
}

export default function ReviewStep({ formData }) {
    const toneLabel = TONE_LABELS[formData.ai_tone] || 'Warm & Professional';
    const treatmentLabel = getTreatmentLabel(formData);

    return (
        <Box>
            <Typography sx={{
                fontSize: 11, fontWeight: 700, letterSpacing: '0.08em',
                textTransform: 'uppercase', color: '#00A76F', mb: '10px',
            }}>
                All done
            </Typography>
            <Typography sx={{
                fontSize: 22, fontWeight: 800, color: '#0D0D0D',
                lineHeight: 1.3, letterSpacing: '-0.4px', mb: 1,
            }}>
                WhatsApp AI is ready to go
            </Typography>
            <Typography sx={{ fontSize: 13.5, color: '#7A7A7A', lineHeight: 1.6, mb: '28px' }}>
                Review your choices below. You can update any setting later from <strong>Settings → WhatsApp AI</strong>.
            </Typography>

            <Box sx={{
                display: 'flex', flexDirection: 'column',
                borderRadius: '16px', border: '1.5px solid #EBEBEB',
                overflow: 'hidden', mb: '20px',
            }}>
                <SummaryRow emoji="🌙" label="Out-of-hours replies" isOn={formData.out_of_hours_enabled} />
                <SummaryRow
                    emoji="🦷"
                    label="Treatment enquiries"
                    isOn={formData.auto_assign_treatment}
                    value={treatmentLabel}
                />
                <SummaryRow emoji="📅" label="Appointment acknowledgement" isOn={formData.appt_ack_enabled} />
                <SummaryRow emoji="💬" label="Opening hours auto-reply" isOn={formData.auto_reply_hours} />
                <SummaryRow emoji="💬" label="Location auto-reply" isOn={formData.auto_reply_location} />
                <SummaryRow emoji="🚨" label="Emergency detection" isOn={formData.urgent_detect} />
                <SummaryRow emoji="🎯" label="WhatsApp AI tone" isOn value={toneLabel} />
            </Box>
        </Box>
    );
}

ReviewStep.propTypes = {
    formData: PropTypes.object.isRequired,
};
